import React from 'react';
import NFTPriceSymbol from '../../../components/NFTPriceSymbol';
import { SaleTokenList } from '../../../data/SaleTokenList';
import Counter from '../../../newComponents/Counter';
import SalePageHeader from './SalePageHeader';
import { SaleMintPrice, SaleMintSection, SalePageCards, SalePageWrapper } from './styled';

/*@ts-ignore */
import FlipCountdown from '@rumess/react-flip-countdown';
import { useDarkModeManager } from '../../../../../state/user/hooks';
import NFTButton from '../../../newComponents/NFTButton';
import Scrollbar from '../../../components/Scrollbar';
import useSale from '../../../../../hooks/useSale';
import { ISaleItem } from '../../../data/SaleList';
import { useAddPopup, useWalletModalToggle } from '../../../../../state/application/hooks';
import { useActiveWeb3React } from '../../../../../hooks';
import { Helmet } from 'react-helmet';
import { getCollectionWithCount } from '../../../../../services/NFTMarketPlace/Graphquery';
import { ChainId } from '@yetiswap/sdk';
import { INFTCollectionItems } from '../../../models/INFTCollectionItems';
import CardCarousel from '../../../newComponents/CardCarousel';
import NFTCollectionCard from '../../Collection/NFTCollectionCard';
import { useGetYetiswapMarketCommissionRateYTS, useGetYetiswapMarketCommissionRateNonYTS } from '../../../../../hooks/useNFTMarketPlace';
import { getTokenPrice } from '../../../../../services/NFTMarketPlace/ApiCall';
import IPriceInfo from '../../../models/IPriceInfo';

interface IHeartBeatsSalePageProps {
    saleData: ISaleItem;
}

const HeartBeatsSalePage = (props: IHeartBeatsSalePageProps) => {
    const { account, active } = useActiveWeb3React();
    const { setMintAmount, calculatingPriceText, calculatingPrice, hasSaleStarted, mintNFT, startTime } = useSale(props.saleData.name);
    //const startTime = null;
    const [darkMode] = useDarkModeManager()
    const [mintEnable, setMintEnable] = React.useState<boolean>(true);
    const [collectionData, setCollectionData] = React.useState<INFTCollectionItems[]>([])
    const [priceInfo, setPriceInfo] = React.useState<IPriceInfo | null>(null)
    const yetiswapMarketCommissionRateYTS = useGetYetiswapMarketCommissionRateYTS()
    const yetiswapMarketCommissionRateNonYTS = useGetYetiswapMarketCommissionRateNonYTS()
    const toggleWalletModal = useWalletModalToggle()

    React.useEffect(() => {
        getTokenPrice().then((res: any) => setPriceInfo(res))
    }, [])

    React.useEffect(() => {
        getCollectionWithCount(props.saleData.Addresses[ChainId.BOBA], 0, 5).then(res => {
            if (res) setCollectionData(res);
        })
    }, []);

    const addPopup = useAddPopup();

    const onChange = (count: number) => {
        setMintAmount(count);
    }

    const ClaimNFT = () => {
        if(!account){
            toggleWalletModal();
            return;
        }
        if (mintNFT && mintEnable && calculatingPrice > 0 && hasSaleStarted) {
            setMintEnable(false)
            mintNFT().then(e => {
                setMintEnable(true)
            }).catch(e => {
                setMintEnable(true)
                addPopup({
                    txn: { hash: "", success: false, summary: "NFT Mint Failed", linkRemove: true }
                });
            })
        }
    }

    return (
        <Scrollbar>
            <Helmet>
                <title>{props.saleData.title} on YetiSwap NFT Marketplace</title>
            </Helmet>
            <SalePageWrapper>
                <SalePageHeader saleData={props.saleData} />
                <SaleMintSection>
                    <div style={{ padding: '2rem' }}>{props.saleData.description}</div>
                    <Counter onChange={onChange} max={5} min={1} />
                    <SaleMintPrice>
                        {"Price: "}
                        <NFTPriceSymbol symbol={<h3>{calculatingPriceText + " AVAX"}</h3> as any} image={SaleTokenList[1].image} />
                    </SaleMintPrice>
                    { hasSaleStarted &&
                        <FlipCountdown
                            hideYear
                            hideMonth
                            //endAtZero
                            size={"medium"}
                            titlePosition={"bottom"}
                            theme={darkMode ? "dark" : 'light'} // Options (Default: dark): dark, light.
                            endAt={startTime ? new Date(startTime).toISOString() : props.saleData.saleDate} // Date/Time
                        >
                            <NFTButton style={{ flex: 'unset', width: '200px' }} onClick={ClaimNFT} disabled={!mintEnable || !active}>{account && active ? "Mint" : "Connect Your Account to Mint"}</NFTButton>
                        </FlipCountdown>
                    }
                    {collectionData.length > 0 &&
                        <SalePageCards>
                            <CardCarousel noCardAnimation autoPlay={true} autoPlaySpeed={2000} spread={"wide"}>
                                {collectionData.map((data, index) => {
                                    return (
                                        <NFTCollectionCard
                                            key={`${index}_WALLET_CARD_${data.tokenID}`}
                                            contractAddress={data.contract.id}
                                            yetiswapMarketCommissionRateYTS={yetiswapMarketCommissionRateYTS}
                                            yetiswapMarketCommissionRateNonYTS={yetiswapMarketCommissionRateNonYTS}
                                            account={account ? account : ''}
                                            tokenId={+data.tokenID}
                                            owner={data.owner.id}
                                            priceInfo={priceInfo}
                                            noButtons
                                        />
                                    )

                                })}
                            </CardCarousel>
                        </SalePageCards>
                    }
                </SaleMintSection>
            </SalePageWrapper>
        </Scrollbar>
    )
}
export default HeartBeatsSalePage;